<template>
  <view class="error-page" wx:style="{{styleBackgroundColor}}">
    <view
      wx:if="{{isShowRule}}"
      class="rule"
      wx:style="{{styleRule}}"
      bindtap="goRulePage"
      >规则</view
    >
    <image class="error-image" src="{{styleBackgroundImg}}" mode="widthFix" />
    <view class="error-content">
      <image
        class="error-icon"
        src="https://dpubstatic.udache.com/static/dpubimg/3GcYtLCWHZQqxFKWwcgeh.png"
        mode="widthFix"
      />
      <view class="error-text">{{
        message || '活动太火爆了，请稍后重试'
      }}</view>
      <view wx:if="{{ countdown > 0 }}" class="redirect-text"
        >即将为您跳转最新活动
        <text>({{ countdown }}s)…</text>
      </view>
    </view>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'
import { trackEvent, utils } from '@didi/webx-js'
import { gotoLink } from '../../lib/utils'
import { rpx } from '../../lib/editor/utils'

  createComponent({
    properties: {
      exception: {
        type: Object,
        value: {},
      },
      error: {
        type: Number,
        value: 0,
      },
      message: {
        type: String,
        value: '',
      },
      isKf: {
        type: Boolean,
        value: false,
      },
    },
    data: {
      countdown: 3,
    },
    attached() {
      this.startCountdown()
      trackEvent('userteam_fx_home_whitepg_sw', '“立即领取”按钮', {
        status_code: this.error,
        msg: this.message,
      })
    },
    computed: {
      // 是否展示规则
      isShowRule() {
        return this.exception?.rule?.link
      },
      // 背景色
      styleBackgroundColor() {
        const defaultColor = this.isKf ? '#8318F5' : '#fff6ea'
        const { backgroundColor = defaultColor } = this.exception || {}
        return { backgroundColor }
      },
      // 背景图
      styleBackgroundImg() {
        const defaultImg = this.isKf
          ? 'https://ut-static.udache.com/webx/ut/b7erL4ogrWFrv3QEV8tuQ.png'
          : 'https://dpubstatic.udache.com/static/dpubimg/6in9uiA-leWw8Rj3CK2o3.png'

        return utils.webpUrl(this.exception?.background || defaultImg)
      },
      // 规则样式
      styleRule() {
        const {
          ruleTop = 130,
          backgroundColor = 'rgba(0, 0, 0, 0.2)',
          color = '#ffffff',
        } = this.exception?.rule || {}
        return { top: rpx(ruleTop), backgroundColor, color }
      },
    },
    methods: {
      // 跳转规则页
      goRulePage() {
        // 编辑器模式下不执行点击操作
        if (process.env.MODE === 'editor') return
        const url = this.exception.rule.link
        gotoLink({ url })
      },

      // 倒计时跳转
      startCountdown() {
        // 编辑器模式下不执行倒计时和自动跳转操作
        if (process.env.MODE === 'editor') return

        const defaultLink = this.isKf? 'https://x.huaxz.cn/x/znRjnDn' : 'https://v.didi.cn/ZeBWOPp'
        const defaultAlipayLink= this.isKf? 'https://x.huaxz.cn/x/D3nDoGn' : 'https://v.didi.cn/p/ZPDQZm7'
        const defaultAppLink = this.isKf? 'kfhxztravel://king_flower/home' : 'Onetravel://home/entrance'

        const {
          link = defaultLink,
          alipay_link = defaultAlipayLink,
          appLink = defaultAppLink,
        } = this.exception || {}

        const timer = setInterval(() => {
          this.countdown--
          if (this.countdown <= 0) {
            clearInterval(timer)
            // 开发环境下不自动跳转
            if (process.env.NODE_ENV === 'development') return
            gotoLink({ link, alipay_link, appLink })
          }
        }, 1000)
      },
    },
  })
</script>

<style lang="scss" scoped>
  .error-page {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    padding-bottom: 44rpx;
  }
  .rule {
    position: absolute;
    width: 84rpx;
    height: 37rpx;
    right: 0;
    border-radius: 27rpx 0 0 27rpx;
    font-family: AlibabaPuHuiTi_2_65_Medium;
    font-size: 24rpx;
    line-height: 37rpx;
    letter-spacing: 1rpx;
    text-align: center;
    font-weight: 500;
  }
  .error-image {
    width: 100%;
    height: auto;
    margin-bottom: -140rpx;
  }
  .error-content {
    width: 700rpx;
    height: 1080rpx;
    background: #ffffff;
    border-radius: 36rpx;
    text-align: center;
  }
  .error-icon {
    margin-top: 60rpx;
    width: 163rpx;
    height: 163rpx;
  }
  .error-text {
    margin-top: 20rpx;
    font-family: PingFangSC-Regular;
    font-size: 27rpx;
    color: #333333;
    letter-spacing: 0.9rpx;
    text-align: center;
    line-height: 60rpx;
    font-weight: 400;
  }
  .redirect-text {
    font-family: PingFangSC-Regular;
    font-size: 24rpx;
    color: #f18d56;
    letter-spacing: 0.8rpx;
    text-align: center;
    line-height: 60rpx;
    font-weight: 400;
  }
</style>

<script type="application/json">
  {
    "component": true
  }
</script>
